<div class="modal-header">
  <div class="modal-title">
    <h3>Book conference room</h3>
    <div><small>Already have an account? <strong><a class="underline" [routerLink]="loginRedirectPath" (click)="close()">Sign In</a></strong></small></div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="submitted"></button>
</div>


<div class="modal-body">

  <div class="section-booking-details mb-3">
    <div>{{ room.name }} at {{ room.place!.name! }}</div>
    <div><strong>{{ availability.localBegin | moment: "ddd, MMM Do, YYYY" }}, {{ availability.localBegin | moment: "h:mm A" }} to {{ availability.localEnd | moment: "h:mm A" }}</strong></div>
  </div>

  <div class="section-signup">
    <form id="form" (ngSubmit)="submit()" ngNativeValidate>

      <div class="input-group mb-3">
        <span class="input-group-text">
          <i class="bi bi-person"></i>
        </span>
        <div class="form-floating">
          <input id="fullName" type="text" name="name" [(ngModel)]="fullName" class="form-control" placeholder="Your name" required>
          <label for="fullName">Your name</label>
        </div>
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text">
          <i class="bi bi-envelope"></i>
        </span>
        <div class="form-floating">
          <input id="email" type="email" name="email" [(ngModel)]="email" class="form-control" placeholder="Email" required>
          <label for="email">Email</label>
        </div>
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text"><i class="bi bi-shield-lock"></i></span>
        <div class="form-floating">
          <input id="password" type="password" name="password" [(ngModel)]="password" class="form-control" placeholder="Password" required>
          <label for="password">Password</label>
        </div>
      </div>

    </form>
  </div>

  <div class="section-payment mb-3">
    <app-payment-form paypalInstructions="Create Account & Book Room"
                      (onPaymentFormLoaded)="onPaymentFormLoaded($event)"
                      (onPaymentFormValid)="onPaymentFormValid($event)"/>
  </div>

  <div class="section-legal mb-3">
    <div class="text-center">
      <small style="color:gray">By booking a conference room, you agree to the Croissant <br/><a routerLink="/terms" class="underline-text" target="_blank">Terms of Service</a> and <a routerLink="/privacy" class="underline-text" target="_blank">Privacy Policy</a>.</small>
    </div>
  </div>

  <div class="section-confirm">
    <button class="btn btn-block btn-neon-blue" form="form" [disabled]="submitted">
      <span>Create Account & Book Room for {{ bookingPrice!.totalBalance! / 100 | money: room.currency! : 2 : false }}</span>
      <span *ngIf="submitted" class="spinner-border spinner-border ms-2"></span>
    </button>
  </div>

</div>


